import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function UsedCarLoans() {
  const navigate = useNavigate();
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16" data-testid="used-car-loans-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">Used Car Loans</div>
      <h1 className="text-4xl lg:text-5xl font-semibold text-slate-900 leading-tight">Financing that understands the vehicle, not just the borrower.</h1>
      <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">
        Every CarFin loan is anchored to a CarDr diagnostic report. We adjust loan-to-value, pricing and tenure based on the real-world condition of the vehicle — not just dealer quoted prices.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
        {[
          { label: "Min loan", value: "₹1,00,000" },
          { label: "Max loan", value: "₹50,00,000" },
          { label: "Tenure", value: "12–84 months" },
          { label: "ROI", value: "12.5% onwards" },
          { label: "Processing fee", value: "1.5%" },
          { label: "Max LTV (Grade A)", value: "80%" },
        ].map((s, i) => (
          <Card key={i} className="p-5 border-slate-200">
            <div className="text-xs uppercase tracking-wider text-slate-500">{s.label}</div>
            <div className="text-xl font-semibold text-slate-900 mt-1 font-mono">{s.value}</div>
          </Card>
        ))}
      </div>

      <h2 className="text-2xl font-semibold text-slate-900 mt-14 mb-5">Eligibility at a glance</h2>
      <Card className="p-6 border-slate-200">
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-slate-700">
          <li>• Age 21–60 (loan maturity)</li>
          <li>• Minimum monthly income ₹20,000</li>
          <li>• CIBIL score 650 and above</li>
          <li>• Salaried, self-employed or business owner</li>
          <li>• Vehicle age &lt; 12 years at loan maturity</li>
          <li>• Odometer &lt; 1.5 lakh km (manual review beyond)</li>
        </ul>
      </Card>

      <div className="mt-12 flex gap-3">
        <Button className="bg-teal-600 hover:bg-teal-700" onClick={() => navigate("/apply")} data-testid="used-cars-apply-btn">Apply for Loan</Button>
        <Button variant="outline" onClick={() => navigate("/how-it-works")}>See how it works</Button>
      </div>
    </div>
  );
}
